module.exports = __webpack_public_path__ + "static/media/sprite.4f40e260.png";


//////////////////
// WEBPACK FOOTER
// ./src/CSS/assets-minified/images/default/sprite.png
// module id = ./src/CSS/assets-minified/images/default/sprite.png
// module chunks = 0